import React, { memo } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { spacing, color, mq } from 'core/theme'
import { useI18n } from 'core/i18n/i18nContext'
import T from 'core/i18n/T'
import { usePageContext } from 'core/helpers/pageContext'
import { getBlockNoteKey } from 'core/helpers/blockHelpers'

const BlockNote = ({ block }) => {
    const context = usePageContext()
    const { translate } = useI18n()
    const key = getBlockNoteKey(block, context)
    const blockNote = translate(key, {}, null)
    if (blockNote) {
        return (
            <Note className="Block__Note">
                <T k={key} md={true} />
            </Note>
        )
    } else {
        return null
    }
}

BlockNote.propTypes = {
    block: PropTypes.shape({
        id: PropTypes.string.isRequired,
        title: PropTypes.node,
        titleId: PropTypes.string,
        description: PropTypes.node,
        descriptionId: PropTypes.string
    }).isRequired
}

const Note = styled.div`
    background: ${color('hint')};
    padding: ${spacing()};
    margin-top: ${spacing(2)};
    font-size: 18px;
    p {
        font-weight: bold;
        margin: 0;
        padding-left: 16px;
    }
    ul {
        font-weight: 400;
        margin: 0;
        padding-left: 32px;
    }
    ol {
        margin: 0;
    }
    li {
        margin-top: 16px;
    }
    span.formula {
        display: inline-flex;
        align-items:center;
        margin-top: 16px;
    }
    div.fraction {
        display:inline-flex;
        flex-direction:column;
        justify-content:center;
        align-items:center;
    }
    div.num {
        border-bottom: 0.5px solid;
        text-align:center;
        font-size: 0.8em;
        width: 100%;
    }
        
    div.denom {
        font-size: 0.8em;
        border-top: 0.5px solid;
        text-align: center;
        width: 100%;
    }

    @media ${mq.small} {
        font-size: 12px;
        padding-left: 5px;
    }
`

export default memo(BlockNote)
